var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from "@angular/core";
import { BrowserXhr } from "@angular/http";
import { ProgressBrowserXhr } from "./ProgressBrowserXhr";
var ProgressBrowserXhrFactory = (function () {
    function ProgressBrowserXhrFactory(browserXhr) {
        this.browserXhr = browserXhr;
    }
    ProgressBrowserXhrFactory.prototype.create = function (upload, download) {
        return new ProgressBrowserXhr(this.browserXhr, upload, download);
    };
    return ProgressBrowserXhrFactory;
}());
ProgressBrowserXhrFactory = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [BrowserXhr])
], ProgressBrowserXhrFactory);
export { ProgressBrowserXhrFactory };
//# sourceMappingURL=ProgressBrowserXhrFactory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-progress-http/lib/ProgressBrowserXhrFactory.js
// module id = 530
// module chunks = 3